import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream-light" data-id="element-219">
      <HeroSection data-id="element-220" />
      <PainSection data-id="element-221" />
      <TruthSection data-id="element-222" />
      <MechanismSection data-id="element-223" />
      <BenefitsSection data-id="element-224" />
      <AudienceSection data-id="element-225" />
      <PricingSection data-id="element-226" />
      <Footer data-id="element-227" />
    </main>;
}